import React from 'react';
import { TEXT_COLOR, TEXT_SIZE, TITLE_SIZE } from '~/utils/constants';

const TextTemplate = (data: TextTemplate) => {
  const defaultFontSize = data.as === 'p' ? TEXT_SIZE : TITLE_SIZE;
  const textStyle = {
    color: data.color ?? TEXT_COLOR,
    fontSize: `${data.font_size || defaultFontSize}rem`,
  };

  const HtmlTemplate = data.as || 'div';

  return (
    <HtmlTemplate
      className='m-0 p-0 leading-tight'
      dangerouslySetInnerHTML={{
        __html: data.text,
      }}
      style={textStyle}
    />
  );
};

export { TextTemplate };
